import {
  alpha,
  Button,
  Group,
  SimpleGrid,
  Stack,
  ThemeIcon,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  getNodeDetails,
  nodeActionsOrdered,
  nodeSecondaryActions,
} from "../flowSettings";
import Locked from "../../../../../../components/View/Locked";
import { IconInfoCircle } from "@tabler/icons-react";
import BackButton from "../../../../../../components/View/BackButton";
import { modals } from "@mantine/modals";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const AddStep = ({
  handleActionClick,
  handleClose = modals.closeAll,
  noEvent,
}) => {
  const lang = useLanguage(s => s.language)
  return (
    <Stack gap={0} px={128} py={handleClose ? 0 : 32}>
      <Title order={4}>{lang.campaign.add_automatic_step}</Title>

      {nodeActionsOrdered.map((group, group_index) => (
        <SimpleGrid key={group[0]} cols={2} my={"md"}>
          {group.map((item) => (
            <Locked
              disableLock={item === "email"}
              buttonProps={{ size: "lg", radius: "lg" }}
              top={4}
              right={-8}
              key={item}
              iconOnly
              withStar
              starProps={{ size: "xs" }}
              starTop={-4}
              starLeft={-4}
            >
              {(isLocked) => (
                <Button
                  key={item}
                  disabled={isLocked}
                  leftSection={
                    <ThemeIcon
                      variant="filled"
                      color={getNodeDetails(item).color}
                      radius={"sm"}
                      size={32}
                    >
                      {getNodeDetails(item, { size: 16 }).icon}
                    </ThemeIcon>
                  }
                  color={"#000"}
                  bg={alpha(getNodeDetails(item).color, 0.1)}
                  variant="light"
                  size="lg"
                  radius={16}
                  w={"100%"}
                  onClick={() => handleActionClick(item)}
                  justify="start"
                  style={{
                    border: "1px solid",
                    borderColor: alpha(getNodeDetails(item).color, 0.2),
                  }}
                  rightSection={
                    <Tooltip label={getNodeDetails(item).tip}>
                      <IconInfoCircle
                        size={20}
                        color={getNodeDetails(item).color}
                      />
                    </Tooltip>
                  }
                  className="workflow-action-button"
                >
                  {getNodeDetails(item).label}
                </Button>
              )}
            </Locked>
          ))}
        </SimpleGrid>
      ))}

      <Title order={4} mt={"xl"}>
        {lang.campaign.add_manual_step}
      </Title>

      <SimpleGrid cols={2} mt={"md"}>
        {nodeSecondaryActions
          .filter((x) =>
            noEvent ? !["event", "remove_prospect"].includes(x) : true,
          )
          .map((item) => (
            <Locked
              disableLock={item === "email"}
              buttonProps={{ size: "sm", radius: "sm" }}
              top={4}
              right={-8}
              key={item}
              iconOnly
              withStar
              starProps={{ size: "xs" }}
              starTop={-4}
              starLeft={-4}
            >
              {(isLocked) => (
                <Button
                  key={item}
                  disabled={isLocked}
                  leftSection={
                    <ThemeIcon
                      variant="filled"
                      color={getNodeDetails(item).color}
                      radius={"sm"}
                      size={26}
                    >
                      {getNodeDetails(item, { size: 18 }).icon}
                    </ThemeIcon>
                  }
                  color={"#000"}
                  bg={alpha(getNodeDetails(item).color, 0.1)}
                  variant="light"
                  size="lg"
                  radius={10}
                  w={"100%"}
                  onClick={() => handleActionClick(item)}
                  justify="start"
                  rightSection={
                    <Tooltip label={getNodeDetails(item).tip}>
                      <IconInfoCircle
                        size={20}
                        color={getNodeDetails(item).color}
                      />
                    </Tooltip>
                  }
                  className="workflow-action-button"
                >
                  {getNodeDetails(item).label}
                </Button>
              )}
            </Locked>
          ))}
      </SimpleGrid>

      {handleClose && (
        <Group justify="end" mt={32} mb={4}>
          <BackButton size="md" onClick={handleClose} />
        </Group>
      )}
    </Stack>
  );
};

export default AddStep;
